import { Event } from "../../contracts";
import { LiveGameState } from "sbtech-sports-data-api-contracts";
import { isNumber } from "util";
import { parseTimeFromSeconds } from "../../helpers";

export const mapGameTime = (x: Event) => {
    x.gameTime = getGameTime(x);
    return x;
}

const getGameTime = (x: Event) => {
    if (!x.liveGameState || !isNumber(x.liveGameState.gameTime)) {
        return "";
    }
    return isEventInHalfTime(x.liveGameState) ? "" : parseTimeFromSeconds(x.liveGameState.gameTime);
}

const isEventInHalfTime = (liveGameState: LiveGameState) => {
    return liveGameState.gamePart && liveGameState
        .gamePart
        .startsWith("Break");
}